import { useTranslation } from "react-i18next";

function NavButton({
  isActive,
  title,
  children
}) {
  const baseClasses = "w-full h-full flex text-start items-center hover:bg-modern-bgLight p-3 md:px-3 md:py-5 rounded-xl transition cursor-pointer";
  const activeClasses = "bg-modern-bgLight shadow-md border-2 border-modern-accent active";
  const inactiveClasses = "bg-transparent";
  const { t } = useTranslation();

  return (
    <div
      className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
    >
      <div className={`inline-flex shrink-0 justify-center items-center size-[48px] rounded-full border-4 ${isActive ? 'border-modern-accent bg-modern-accentLight bg-opacity-10' : 'border-modern-border'}` }>
        {children}
      </div>
      <div className="ml-2 md:size-auto">
        <span className={`block font-bold ${isActive ? 'text-modern-primary' : 'text-modern-textMedium'}`}>
          {t(title)}
        </span>
      </div>
    </div>
  );
}

export default NavButton;
